/** 资料下载 / X86 详情共用的桌面镜像包元数据（配置在 public/data.json） */
import dataJson from "@/../public/data.json";

export type DesktopPackageMeta = {
  version: string;
  size: string;
  release_date: string;
  update_notes: string;
};

export type DesktopPackageItem = {
  title?: string;
  sub_title?: string;
  describe?: string;
  download?: string;
  package_meta?: DesktopPackageMeta;
};

/** 供资料下载卡片：有 package_meta 时生成 describe HTML，避免与 X86 详情字段重复维护 */
export function buildDescribeHtmlFromPackageMeta(
  item: DesktopPackageItem,
): string | null {
  const m = item?.package_meta;
  if (!m?.version || !m.size || !m.release_date) return null;
  const notes = m.update_notes ?? "";
  return `版本号：${m.version}&nbsp;&nbsp;大小：${m.size}&nbsp;&nbsp;更新日期：${m.release_date}<br/>更新说明：${notes}`;
}

export function mergeDesktopDownloadGroups(
  ...groupLists: unknown[][]
): unknown[] {
  return groupLists.flatMap((groups) => (Array.isArray(groups) ? groups : []));
}

export function getAllDesktopDownloadGroups(): unknown[] {
  const fd = (dataJson as { free_download?: Record<string, unknown> })
    .free_download;
  if (!fd) return [];
  return mergeDesktopDownloadGroups(
    fd.desktop_x86_version_download as unknown[],
    fd.desktop_version_download as unknown[],
  );
}

export function findDesktopPackageByDownloadKey(
  desktopGroups: unknown,
  downloadKey: string,
): DesktopPackageItem | null {
  if (!Array.isArray(desktopGroups)) return null;
  for (const group of desktopGroups as { list?: DesktopPackageItem[] }[]) {
    const list = group?.list;
    if (!Array.isArray(list)) continue;
    const found = list.find((it) => it?.download === downloadKey);
    if (found) return found;
    for (const it of list) {
      const nested = (it as DesktopPackageItem & { downloadTypeList?: { download?: string; label?: string }[] })
        ?.downloadTypeList;
      if (!Array.isArray(nested)) continue;
      const hit = nested.find((n) => n?.download === downloadKey);
      if (hit != null) {
        return {
          ...it,
          download: hit.download,
          sub_title: hit.label ?? it?.sub_title,
        };
      }
    }
  }
  return null;
}

/** 桌面专区中带「外链」按钮的配置（如 RKDevTool），key 为 RESOURCE_MAP 的 link key */
export function findDesktopPackageByLinkKey(
  desktopGroups: unknown,
  linkKey: string,
): DesktopPackageItem | null {
  if (!Array.isArray(desktopGroups)) return null;
  for (const group of desktopGroups as { list?: (DesktopPackageItem & { link?: string })[] }[]) {
    const list = group?.list;
    if (!Array.isArray(list)) continue;
    const found = list.find((it) => it?.link === linkKey);
    if (found) return found;
  }
  return null;
}
